/**
 * 教科の定数定義
 */
export namespace SubjectCode {
  // 国語
  export const JAPANESE: SubjectMaster = {
    code: 'j',
    label: '国語',
    color: '--color-subject-ko',
  }

  // 算数
  export const MATH: SubjectMaster = {
    code: 'm',
    label: '算数',
    color: '--color-subject-su',
  }

  // 英語
  export const ENGLISH: SubjectMaster = {
    code: 'e',
    label: '英語',
    color: '--color-subject-ei',
  }

  // 理科
  export const SCIENCE: SubjectMaster = {
    code: 'r',
    label: '理科',
    color: '--color-subject-ri',
  }

  // 社会
  export const SOCIAL: SubjectMaster = {
    code: 's',
    label: '社会',
    color: '--color-subject-sy',
  }

  // 教科一覧
  // N_LMS-395 初期リリース段階での教科・学年の制限に伴う内容修正
  export const LIST = [MATH]
  // export const LIST = [JAPANESE, MATH, ENGLISH, SCIENCE, SOCIAL]

  /**
   * codeの値から該当する定数を見つけて返す
   *
   * @param code 教科コード
   * @returns 教科の定数
   */
  export function findByCode(code: string): SubjectMaster | undefined {
    return SubjectCode.LIST.find((subject) => {
      return subject.code === code
    })
  }

  /**
   * 教科のマスター定義
   */
  export type SubjectMaster = {
    /** 教科コード */
    code: string
    /** ラベル */
    label: string
    /** css:色指定 */
    color: string
  }
}
